// Book Away single source of truth for support / contact.
export const CONTACT_EMAIL = "hello@bookaway.com.au";
export const CONTACT_MAILTO = `mailto:${CONTACT_EMAIL}`;
